import { BulkCustomersReducer, BulkCustomersReducerStateWithListObject, BulkCustomersReducerStateWithoutListObject, bulkCustomersType } from "./types";


const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
  data: {},
  loading: false,
  error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  loading: false,
  error: null
};
const UploadBulkCustomersReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.UPLOAD_BULK_CUSTOMERS: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.UPLOAD_BULK_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.UPLOAD_BULK_CUSTOMERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_UPLOAD_BULK_CUSTOMERS: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};

const ListBulkCustomersReducer = (state: BulkCustomersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.FETCH_BULK_CUSTOMERS: {
      return {
        ...state,
        loading: true
      };
    }
    case bulkCustomersType.FETCH_BULK_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case bulkCustomersType.FETCH_BULK_CUSTOMERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }

    case bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const BulkCustomersDetailReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.FETCH_BULK_CUSTOMERS_DETAIL_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_FETCH_BULK_CUSTOMERS_DETAIL: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};

const BulkCustomersVersionRecordReducer = (state: BulkCustomersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.BULK_CUSTOMERS_VERSION: {
      return {
        ...state,
        loading: true
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_VERSION_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_VERSION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }

    case bulkCustomersType.RESET_BULK_CUSTOMERS_VERSION:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const BulkCustomersPublishReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.BULK_CUSTOMERS_PUBLISH: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_PUBLISH_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_PUBLISH_ERROR: {
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_BULK_CUSTOMERS_PUBLISH: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};

const DownloaBulkCustomersReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD: {
      return {
        loading: true
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case bulkCustomersType.BULK_CUSTOMERS_FILE_DOWNLOAD_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case bulkCustomersType.RESET_BULK_CUSTOMERS_FILE_DOWNLOAD:
      return {
        data: {},
        loading: false,
        error: null
      };
    default:
      return { ...state };
  }
}

const ListBulkFileSpecificCustomersReducer = (state: BulkCustomersReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS: {
      return {
        ...state,
        loading: true
      };
    }
    case bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data
      };
    }
    case bulkCustomersType.FETCH_BULK_FILE_SPECIFIC_CUSTOMERS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }

    case bulkCustomersType.RESET_FETCH_BULK_FILE_SPECIFIC_CUSTOMERS:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const ApproveBulkCustomersFileReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.APPROVE_BULK_CUSTOMERS_FILE_ERROR: {
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_APPROVE_BULK_CUSTOMERS_FILE: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};


const RejectBulkCustomersFileReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.REJECT_BULK_CUSTOMERS_FILE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_REJECT_BULK_CUSTOMERS_FILE: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};

const DeDuplicateBulkCustomersFileCheckReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case bulkCustomersType.RESET_DEDUPLICATE_BULK_CUSTOMERS_FILE_CHECK: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }

    default:
      return { ...state };
  }
};

const DeleteBulkCustomersFileReducer = (state: BulkCustomersReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkCustomersReducer) => {
  switch (action.type) {
    case bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE: {
      return {
        loading: true,
      };
    }
    case bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null
      };
    }
    case bulkCustomersType.DELETE_BULK_CUSTOMERS_FILE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: {}
      };
    }
    case bulkCustomersType.RESET_DELETE_BULK_CUSTOMERS_FILE: {
      return {
        data: {},
        loading: false,
        error: null
      };
    }
    default:
      return { ...state };
  }
};


export {
  UploadBulkCustomersReducer,
  ListBulkCustomersReducer,
  BulkCustomersDetailReducer,
  BulkCustomersVersionRecordReducer,
  BulkCustomersPublishReducer,
  DownloaBulkCustomersReducer,
  ListBulkFileSpecificCustomersReducer,
  ApproveBulkCustomersFileReducer,
  RejectBulkCustomersFileReducer,
  DeDuplicateBulkCustomersFileCheckReducer,
  DeleteBulkCustomersFileReducer
}